import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mix': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 64h448v204.1c0 56.6-88 59.9-88 0v-23.8c0-56.8-82.7-59-88-4.3v116.1c0 58-96 57.9-96 0v-175.3c0-56.9-80.1-59.4-88-6.5v238.6c0 58.1-88 56.2-88 0v-348.9z'
      }
    ]
  }
})
